module.exports = __webpack_public_path__ + "static/media/A8.1755327b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A8.png
// module id = 874
// module chunks = 0